import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-edit\"><defs><style type=\"text/css\"></style></defs><path d=\"M14.250667 805.12v204.629333H224.426667L832.853333 395.946667 622.506667 191.146667 14.165333 805.12zM993.194667 235.52a53.504 53.504 0 0 0 0-77.397333l-127.146667-127.146667a53.504 53.504 0 0 0-77.482667 0L688.981333 130.304l210.176 204.629333 94.037334-99.584z\" p-id=\"2503\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol